import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PlacementReviewStudent } from '../models/models.lib';
import { map, tap } from 'rxjs/operators';
import { ApiService } from '../api/api.service';

const { apiUrl } = environment;

export abstract class CasiPlacementReviewStudentService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<PlacementReviewStudent[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/placement/review/student/assessments`))
      .pipe(
        map((response: any, i) => {
          return <PlacementReviewStudent[]>response;
        }),
        map(r => r.map(x => PlacementReviewStudent.create(x))),
        tap(() => (this.loading = false))
      )
  }
}


@Injectable({
  providedIn: 'root'
})
export class AssessmentService extends CasiPlacementReviewStudentService {
  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get(email: string) {
    return this.apiService.postHttpCall(`/placement/review/student/assessments`, { email }, 'get');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`placement/review/student/${id}`, dataItem, 'update');
  }
}

